import { ErrorT } from '../../types/errorT'

const buildSupportEmail = (error: ErrorT) => {
  let resultBody: string | string[] = ''

  if (error.error) {
    if (Array.isArray(error.error)) {
      resultBody = error.error.map((errorDetailItem) => `${errorDetailItem.message}`)
    } else if (error.message) {
      resultBody = error.message
    }
  }

  const subject = `Good To Book error report | ${error.status} | ${error.message}`
  const body = `Technical Details: ${resultBody}
  `
  return `mailto:api-support@goodtobook.com?subject=${subject}&body=${body}`
}

export default buildSupportEmail
